export var SpotterCodeMessageRole;
(function (SpotterCodeMessageRole) {
    SpotterCodeMessageRole["USER"] = "user";
    SpotterCodeMessageRole["ASSISTANT"] = "assistant";
})(SpotterCodeMessageRole || (SpotterCodeMessageRole = {}));
export var SpotterCodeContentPartType;
(function (SpotterCodeContentPartType) {
    SpotterCodeContentPartType["TEXT"] = "text";
    SpotterCodeContentPartType["CODE"] = "code";
    SpotterCodeContentPartType["ERROR"] = "error";
})(SpotterCodeContentPartType || (SpotterCodeContentPartType = {}));
export var SpotterCodeAgentStatus;
(function (SpotterCodeAgentStatus) {
    SpotterCodeAgentStatus["IDLE"] = "idle";
    SpotterCodeAgentStatus["THINKING"] = "thinking";
    SpotterCodeAgentStatus["ERROR"] = "error";
})(SpotterCodeAgentStatus || (SpotterCodeAgentStatus = {}));
export var SpotterCodeAiResponseErrorKey;
(function (SpotterCodeAiResponseErrorKey) {
    SpotterCodeAiResponseErrorKey["USER_CANCELLED_ISSUE"] = "USER_CANCELLED_ISSUE";
    SpotterCodeAiResponseErrorKey["INTERNAL_SERVER_ISSUE"] = "INTERNAL_SERVER_ISSUE";
    SpotterCodeAiResponseErrorKey["TIMEOUT_ISSUE"] = "TIMEOUT_ISSUE";
    SpotterCodeAiResponseErrorKey["CONFLICTING_CODE_ISSUE"] = "CONFLICTING_CODE_ISSUE";
})(SpotterCodeAiResponseErrorKey || (SpotterCodeAiResponseErrorKey = {}));
export var SpotterCodeDiffChangeType;
(function (SpotterCodeDiffChangeType) {
    SpotterCodeDiffChangeType["ADDED"] = "added";
    SpotterCodeDiffChangeType["REMOVED"] = "removed";
    SpotterCodeDiffChangeType["UNCHANGED"] = "unchanged";
})(SpotterCodeDiffChangeType || (SpotterCodeDiffChangeType = {}));
//# sourceMappingURL=spotter-code.js.map